// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"e2f02059","595":"9bb5d951","753":"c4e75579","787":"9c27d52a"}[chunkId] + ".chunk.js";
};